export default __webpack_public_path__ + "images/JM.8cd3cbc.png";